import { OCCUPATION_TYPES } from './formModel.types';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
var t = getTranslation(translations);
var occupationTypesForSalariedEmployee = [
    OCCUPATION_TYPES.EMPLOYEE,
    OCCUPATION_TYPES.WORKER,
    OCCUPATION_TYPES.OFFICER,
];
var occupationTypesRelatedToCountry = [
    OCCUPATION_TYPES.EMPLOYEE,
    OCCUPATION_TYPES.WORKER,
    OCCUPATION_TYPES.OFFICER,
    OCCUPATION_TYPES.PENSIONER,
];
var occupationTypesWithAnnualIncome = [
    OCCUPATION_TYPES.SELF_EMPLOYED,
    OCCUPATION_TYPES.FREELANCER,
];
var occupationTypeOptions = [
    { value: OCCUPATION_TYPES.EMPLOYEE, label: t.occupationType_employee },
    { value: OCCUPATION_TYPES.WORKER, label: t.occupationType_worker },
    { value: OCCUPATION_TYPES.OFFICER, label: t.occupationType_officer },
    { value: OCCUPATION_TYPES.FREELANCER, label: t.occupationType_freelancer },
    {
        value: OCCUPATION_TYPES.SELF_EMPLOYED,
        label: t.occupationType_selfEmployed,
    },
    { value: OCCUPATION_TYPES.RETIREE, label: t.occupationType_retiree },
    { value: OCCUPATION_TYPES.PENSIONER, label: t.occupationType_pensioner },
    { value: OCCUPATION_TYPES.UNEMPLOYED, label: t.occupationType_unemployed },
    { value: OCCUPATION_TYPES.HOUSEMAKER, label: t.occupationType_houseMaker },
];
var isLimitedOccupationOptions = [
    { value: true, label: t.isLimitedOccupation_yes },
    { value: false, label: t.isLimitedOccupation_no },
];
var employerAddressCountryOptions = [
    { value: 'DE', label: t.employerAddressCountry_isDE },
    { value: null, label: t.employerAddressCountry_isNotDE },
];
var numberOfSalariesPerYearOptions = [
    { value: 12, label: t.numberOfSalariesPerYear_12 },
    { value: 13, label: t.numberOfSalariesPerYear_13 },
    { value: 14, label: t.numberOfSalariesPerYear_moreThan13 },
];
// @todo: [tech-debt] should be used as independent Switcher component with its own translation
var yesOrNotOptions = [
    { value: true, label: t.yes },
    { value: false, label: t.no },
];
export default {
    occupationTypeOptions: occupationTypeOptions,
    employerAddressCountryOptions: employerAddressCountryOptions,
    numberOfSalariesPerYearOptions: numberOfSalariesPerYearOptions,
    yesOrNotOptions: yesOrNotOptions,
    isLimitedOccupationOptions: isLimitedOccupationOptions,
    occupationTypesForSalariedEmployee: occupationTypesForSalariedEmployee,
    occupationTypesRelatedToCountry: occupationTypesRelatedToCountry,
    occupationTypesWithAnnualIncome: occupationTypesWithAnnualIncome,
};
